import request from '@/config/axios'

export interface CommentVO {
  id: number
  feedId: number
  feedContent: string
  userId: number
  userNickname: string
  replyToUserId?: number
  replyToUserNickname?: string
  content: string
  likeCount: number
  status: number
  createTime: string
}

export interface CommentPageReqVO extends PageParam {
  status?: number
  keyword?: string
  userNickname?: string
  feedContent?: string
  createTimeStart?: string
  createTimeEnd?: string
}

export const getCommentPage = (params: CommentPageReqVO) =>
  request.get({ url: '/bosscircle/comment/page', params })
export const updateCommentStatus = (id: number, status: number) =>
  request.put({ url: '/bosscircle/comment/status', params: { id, status } })
export const batchUpdateCommentStatus = (ids: number[], status: number) =>
  request.put({
    url: '/bosscircle/comment/batch-status',
    params: { ids: ids.join(','), status }
  })
export const deleteComment = (id: number) =>
  request.delete({ url: '/bosscircle/comment/delete', params: { id } })
export const batchDeleteComment = (ids: number[]) =>
  request.delete({ url: '/bosscircle/comment/batch-delete', params: { ids: ids.join(',') } })
